import {z} from 'zod'

export const DateRange = z
  .object({
    start: z.iso.datetime({local: true, offset: true}),
    end: z.iso.datetime({local: true, offset: true}),
  })
  .check((ctx) => {
    if (new Date(ctx.value.start).getTime() > new Date(ctx.value.end).getTime()) {
      ctx.issues.push({
        input: ctx.value,
        path: ['start'],
        code: 'custom',
        message: `Start is before end`,
      })
      ctx.issues.push({
        input: ctx.value,
        path: ['end'],
        code: 'custom',
        message: `End is before start`,
      })
    }
  })
export type DateRange = z.infer<typeof DateRange>
